export default {
  TITLE: {
    title: 'Account Recovery'
  },
  DISCLAIMER: {
    title:
      'This information is used to help you get back into your account. An email will be sent with a link to change your password.'
  },
  ERROR: {
    severity: 'error' as 'error',
    title: 'Uh oh!',
    subtitle: 'There was an issue submitting your recovery information.'
  },
  SUCCESS: {
    severity: 'success' as 'success',
    title: 'Success!',
    subtitle:
      "We've sent a link to your email. If you did not receive an email or need assistance, please contact (855)-555-1212."
  }
};
